import React from "react";
import { Box, Typography, Card, CardActionArea, CardContent, Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { COLORS, PageHeader, cardSx } from "../../Components/WorkTransfer/wtStyle";

// Landing page — Sales-mode-only build: "Move someone's work", "Rearrange a
// team", "Update CP Sourcing Manager". Transfer by project and Bulk Lead
// Source Change live in the full (non-sales-only) branch instead. The
// cross-cutting Transfer History view (FR-16/17/18) was removed 2026-09-01 —
// not required; the same lead-level history is already visible on each
// lead's own Timeline/Notes via LeadLogs.
const ENTRY_POINTS = [
  { key: "move-work", label: "Move someone's work", desc: "A person is leaving, on leave, or overloaded — move everything they own.", path: "/home/WorkTransfer/MoveWork", ready: true },
  { key: "rearrange-team", label: "Rearrange a team", desc: "A manager's team has grown too large and needs splitting across several new managers — nobody is leaving.", path: "/home/WorkTransfer/RearrangeTeam", ready: true },
  { key: "cp-sourcing-manager", label: "Update CP Sourcing Manager", desc: "A CP sourcing manager left, or is overloaded — reassign their channel partners.", path: "/home/WorkTransfer/CpSourcingManager", ready: true },
];

export default function WorkTransferHub() {
  const navigate = useNavigate();

  return (
    <Box sx={{ p: 3 }}>
      <PageHeader
        title="Work Transfer"
        subtitle="Move a person's leads, a project's pipeline, or a team's reporting line to someone else — reviewed before anything changes, and logged permanently."
      />
      <Grid container spacing={2}>
        {ENTRY_POINTS.map((ep) => (
          <Grid item xs={12} sm={6} md={4} key={ep.key}>
            <Card
              elevation={0}
              sx={{ ...cardSx, opacity: ep.ready ? 1 : 0.5, transition: "box-shadow .14s, transform .14s", "&:hover": ep.ready ? { boxShadow: "0 4px 14px rgba(17,24,39,.08)", transform: "translateY(-2px)" } : {} }}
            >
              <CardActionArea disabled={!ep.ready} onClick={() => ep.ready && navigate(ep.path)} sx={{ p: 2.5 }}>
                <CardContent sx={{ p: "0 !important" }}>
                  <Typography fontSize={14.5} fontWeight={700}>{ep.label}</Typography>
                  <Typography fontSize={12.5} color={COLORS.textSecondary} sx={{ mt: 0.5 }}>
                    {ep.ready ? ep.desc : "Coming soon"}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}
